// extracted by mini-css-extract-plugin
module.exports = {"button":"GreetingScreen_button__2VTzh","container":"GreetingScreen_container__ou4y2","heading":"GreetingScreen_heading__3q6-F","image":"GreetingScreen_image__1-mGu"};